module.exports = __webpack_public_path__ + "static/media/test1 (12).d80a6538.jpg";